module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/french-54d0db8f834288d96d70b8c370d3d321c71184ec7b06ddd481e7db54c3ec1779.png";